<template>
    <div class="no-padding no-margin">
        <Networks v-if="route == `/employer-advisor/networks`"></Networks>
        <NetworkBuilder  v-if="route == `/employer-advisor/networks/builder`"></NetworkBuilder>
        <Network  v-if="route == `/employer-advisor/networks/network`"></Network>
    </div>
</template>
<script>

import NetworkBuilder from './NetworkBuilder.vue'
import Networks from './NetworksTable.vue'
import Network from './SingleNetwork.vue'
export default{
    data(){
        return{
        
        }
    },
    components:{
        Network,
        NetworkBuilder,
        Networks,
    },
    computed:{
        route(){
            return this.$route.path
        },
        routeParams(){
            return this.$route.params.name
        }
    }
}
</script>